import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CcProductStock from '@/main/webapp/resources/src/vue/domain/productstock/cc-productstock';
import { Utils } from '@/main/webapp/resources/src/vue/infrastructure/utils/helpers';
const CcProductStockControllerComponent = () => import(/* webpackChunkName: 'cc-product-stock-controller' */ '../cc-product-stock-controller/cc-product-stock-controller.vue');

@Component({
	filters: {
		decimal: (value: string) => {
			return new Intl.NumberFormat(navigator.language, { style: 'decimal', minimumFractionDigits: 2 }).format(parseFloat((parseFloat(value) || 0).toFixed(2)));
		},
		price: (value: string) => {
			return new Intl.NumberFormat(navigator.language, { style: 'currency', currency: 'EUR' }).format(parseFloat(value) || 0);
		},
		unit: (value: string, simple: boolean) => {
			const prefix: string = simple ? '' : 'al ';
			return value != null ? prefix + value.toLowerCase() : '';
		}
	},
	components: {
		CcProductStockController: CcProductStockControllerComponent
	}
})
export default class CcProductStockComponent extends Vue {
	static readonly PREVIEW_WIDTH: string = '350';
	static readonly PREVIEW_HEIGHT: string = '350';

	@Prop({ type: Object, default: () => ({}) })
	private productStock!: CcProductStock;

	@Prop({ type: Boolean, default: false })
	private resetEnabled: boolean;

	get productInTheCart (): CcProductStock {
		return this.$store.getters.order.items.find(
			(productStock: CcProductStock) =>
				productStock.product.code === this.productStock.product.code
		);
	}

	get isProductInTheCart (): boolean {
		return typeof this.productInTheCart !== 'undefined';
	}

	get imageUrl (): string {
		return `${Utils.getPermalik('/products')}/${this.productStock.product.code}/images/${this.productStock.product.primaryImage.name}?width=${CcProductStockComponent.PREVIEW_WIDTH}&height=${CcProductStockComponent.PREVIEW_HEIGHT}`;
	}

	get description (): string {
		return this.productStock.product.customerDescription ? this.productStock.product.customerDescription : this.productStock.product.description;
	}

	get unit (): string {
		return this.productStock.product.customerUnit ? this.productStock.product.customerUnit : this.productStock.product.unit;
	}

	get contentUnit (): string {
		return this.productStock.product.contentUnit ? this.productStock.product.contentUnit : this.productStock.product.unit;
	}

	get selectedCategoryPath (): string {
		return this.$store.getters.searchCategoryPaths;
	}

	updated () {
		this.$emit('updateProductStock');
	}
}
